import * as React from "react";
function SvgSurpriseSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2zm-4.516 8.065c0-.714.576-1.29 1.29-1.29.714 0 1.29.576 1.29 1.29 0 .713-.576 1.29-1.29 1.29-.714 0-1.29-.577-1.29-1.29zM12 18.452a2.583 2.583 0 01-2.58-2.581 2.583 2.583 0 012.58-2.58 2.583 2.583 0 012.58 2.58 2.583 2.583 0 01-2.58 2.58zm3.226-7.097c-.714 0-1.29-.577-1.29-1.29 0-.714.576-1.29 1.29-1.29.713 0 1.29.576 1.29 1.29 0 .713-.576 1.29-1.29 1.29z"
        fill="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSurpriseSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
